export default "__VITE_ASSET__ab6736b8__"